// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../resources/layout-and-structure/Box.res.js";
import * as Env from "./Env.res.js";
import * as I18n from "../primitives/I18n.res.js";
import * as Modal from "../resources/overlays/Modal.res.js";
import * as React from "react";
import * as JsonCodec from "../primitives/JsonCodec.res.js";
import * as TextStyle from "../resources/typography/TextStyle.res.js";
import * as Navigation from "../primitives/Navigation.res.js";
import * as SessionTracker from "./SessionTracker.res.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";

let versionCodec = JsonCodec.object2(param => [
  param.commitSha,
  param.forceUserReloadRevision
], param => ({
  TAG: "Ok",
  _0: {
    commitSha: param[0],
    forceUserReloadRevision: param[1]
  }
}), JsonCodec.field("commitSha", JsonCodec.string), JsonCodec.field("forceUserReloadRevision", JsonCodec.int));

function decodeRemote(json) {
  let remote = JsonCodec.decodeWith(json, versionCodec);
  if (remote.TAG === "Ok") {
    return remote._0;
  }
}

async function fetchRemote() {
  try {
    let response = await fetch(window.location.origin + `/version.json?t=` + Date.now().toString(), {
      cache: "no-store"
    });
    if (response.ok) {
      return decodeRemote(await response.json());
    } else {
      return;
    }
  } catch (exn) {
    return;
  }
}

function evaluate(bundle, remote) {
  if (bundle.commitSha === remote.commitSha) {
    return "UpToDate";
  } else if (bundle.forceUserReloadRevision < remote.forceUserReloadRevision) {
    return "Mandatory";
  } else {
    return "Available";
  }
}

let reloadedForStorageKey = "app-version-reloaded-for";

function alreadyReloadedFor(remote) {
  return Primitive_option.fromNull(sessionStorage.getItem(reloadedForStorageKey)) === remote.commitSha;
}

function reloadFor(remote, reload) {
  sessionStorage.setItem(reloadedForStorageKey, remote.commitSha);
  return reload();
}

function AppVersion$AppVersionModal(props) {
  return JsxRuntime.jsx(Modal.make, {
    children: JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsx(TextStyle.make, {
        children: I18n.t("app_version_modal.text"),
        variation: "normal"
      }),
      spaceX: "xlarge",
      spaceY: "xxlarge"
    }),
    opened: true,
    title: I18n.t("app_version_modal.title"),
    variation: "secondary",
    commitButtonTone: "brand",
    commitButtonText: I18n.t("app_version_modal.update"),
    commitButtonIcon: "refresh_v1",
    commitButtonCallback: props.onRequestUpdate
  });
}

function isSubPage(pathname) {
  return pathname.split("/").filter(segment => segment !== "").length > 1;
}

function defaultBundle() {
  let match = Env.appCommitSha();
  let match$1 = Env.appForceUserReloadRevision();
  if (match !== undefined && match$1 !== undefined) {
    return {
      commitSha: match,
      forceUserReloadRevision: match$1
    };
  }
}

function AppVersion$Checker(props) {
  let __reload = props.reload;
  let __bundle = props.bundle;
  let bundle = __bundle !== undefined ? Primitive_option.valFromOption(__bundle) : defaultBundle();
  let reload = __reload !== undefined ? __reload : () => {
      window.location.reload();
    };
  let match = Navigation.useUrl();
  let pathname = match.pathname;
  let captureEvent = SessionTracker.useCaptureEvent();
  let match$1 = React.useState(() => false);
  let setModalOpened = match$1[1];
  let modalOpened = match$1[0];
  let latestRemote = React.useRef(undefined);
  let currentPathname = React.useRef(pathname);
  let check = async () => {
    if (bundle === undefined) {
      return;
    }
    let pathname = currentPathname.current;
    let remote = await fetchRemote();
    if (remote !== undefined) {
      latestRemote.current = remote;
      if (currentPathname.current === pathname && !isSubPage(pathname)) {
        return setModalOpened(param => evaluate(bundle, remote) === "Mandatory");
      } else {
        return;
      }
    }
  };
  React.useEffect(() => {
    if (bundle === undefined) {
      return;
    }
    let checkIfVisible = () => {
      if (document.visibilityState === "visible") {
        check();
        return;
      }
    };
    let intervalId = setInterval(checkIfVisible, 300000);
    let onVisibilityChange = param => checkIfVisible();
    let domDocument = document;
    domDocument.addEventListener("visibilitychange", onVisibilityChange);
    return () => {
      clearInterval(intervalId);
      domDocument.removeEventListener("visibilitychange", onVisibilityChange);
    };
  }, []);
  React.useEffect(() => {
    if (currentPathname.current !== pathname) {
      currentPathname.current = pathname;
      setModalOpened(param => false);
      let match = latestRemote.current;
      if (bundle !== undefined && match !== undefined && evaluate(bundle, match) !== "UpToDate" && !alreadyReloadedFor(match)) {
        reloadFor(match, reload);
      }
    }
  }, [pathname]);
  React.useEffect(() => {
    if (modalOpened) {
      captureEvent("app_version_modal_show");
    }
  }, [modalOpened]);
  let onRequestUpdate = () => {
    let remote = latestRemote.current;
    if (remote !== undefined) {
      return reloadFor(remote, reload);
    } else {
      return reload();
    }
  };
  if (modalOpened) {
    return JsxRuntime.jsx(AppVersion$AppVersionModal, {
      onRequestUpdate: onRequestUpdate
    });
  } else {
    return null;
  }
}

let Checker = {
  make: AppVersion$Checker
};

export {
  decodeRemote,
  evaluate,
  isSubPage,
  Checker,
}
/* versionCodec Not a pure module */
